import React from 'react';
import { QuizClub2023 } from 'views';

const StudentsTestimonialpage = () => {
  return <QuizClub2023 />;
};

export default StudentsTestimonialpage;